export const ICON_HEIGHT = 140;

export const ERROR_TYPES = {
  PAGE_NOT_FOUND: 'PAGE_NOT_FOUND',
  FALLBACK: 'FALLBACK',
} as const;
